import { render, staticRenderFns } from "./fruitNinja.vue?vue&type=template&id=4bd5dff8&scoped=true"
import script from "./fruitNinja.vue?vue&type=script&lang=js"
export * from "./fruitNinja.vue?vue&type=script&lang=js"
import style0 from "./fruitNinja.vue?vue&type=style&index=0&id=4bd5dff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5dff8",
  null
  
)

export default component.exports